export default __webpack_public_path__ + "static/media/05_unnested_prefs.842a200f.png";